/**
 * Centralized API service with token refresh handling
 */

import instance from "./index";
import { handleApiError } from "./errorHandler";

export const executeApiCall = async (apiCall, options = {}) => {
  try {
    const response = await apiCall();
    return response?.data;
  } catch (error) {
    return handleApiError(error, options);
  }
};

export const createApiService = (baseUrl = "") => {
  return {
    get: (endpoint, params = {}, options = {}) => {
      return executeApiCall(
        () => instance(true, baseUrl).get(endpoint, { params }),
        options
      );
    },
    post: (endpoint, data = {}, options = {}) => {
      return executeApiCall(
        () => instance(true, baseUrl).post(endpoint, data),
        options
      );
    },
    put: (endpoint, data = {}, options = {}) => {
      return executeApiCall(
        () => instance(true, baseUrl).put(endpoint, data),
        options
      );
    },
    delete: (endpoint, params = {}, options = {}) => {
      return executeApiCall(
        () => instance(true, baseUrl).delete(endpoint, { params }),
        options
      );
    },
  };
};

export const apiService = createApiService();
